/**
 * 页头会话区 —— me() 驱动(session.ts / me.ts 是唯一身份 oracle)。
 *
 * - loading/error:渲染登录/注册(不暴露身份,也不闪一个空洞);
 * - anonymous:登录 + 注册(注册是主 CTA,给实心按钮);
 * - authed:头像 + 昵称(→ 玩家中心/管理后台)+ 退出。
 *
 * 退出是状态修改 → 用 <button>;走 auth.logout()(CSRF 写),完成后整页
 * 回 /(MPA 导航,顺带让全站重新 bootstrap CSRF/会话)。
 */
import { useState } from 'react';
import { appUrl } from '@web-v4/router-utils';
import { authClient } from '../lib/clients';
import { defaultLanding } from '../lib/navigation';
import { useSession } from '../lib/session';

export interface SiteSessionProps {
  /** 汉堡菜单收起自身(移动端会话区与链接同处一个抽屉外)。 */
  readonly onNavigate?: () => void;
}

export function SiteSession({ onNavigate }: SiteSessionProps) {
  const { state } = useSession();
  const [loggingOut, setLoggingOut] = useState(false);

  if (state.status !== 'authed') {
    return (
      <div className="wv-h2-session">
        <a className="wv-h2-session__link" href={appUrl('portal', '/login')} onClick={onNavigate}>
          登录
        </a>
        <a
          className="wv-h2-btn wv-h2-btn--info wv-h2-btn--sm"
          href={appUrl('portal', '/register')}
          onClick={onNavigate}
        >
          注册
        </a>
      </div>
    );
  }

  const { me } = state;
  return (
    <div className="wv-h2-session">
      <a
        className="wv-h2-session__link wv-h2-session__identity"
        href={defaultLanding(me)}
        onClick={onNavigate}
      >
        {/* 契约 avatar_url 是 /avatars/{username} 游戏兼容 302,可直接进 <img> */}
        <img
          className="wv-h2-session__avatar"
          src={me.user.avatar_url}
          alt=""
          width={26}
          height={26}
        />
        <span className="wv-h2-session__name">{me.user.username}</span>
      </a>
      <button
        type="button"
        className="wv-h2-session__logout"
        disabled={loggingOut}
        onClick={() => {
          setLoggingOut(true);
          authClient.logout().finally(() => {
            window.location.assign(appUrl('portal'));
          });
        }}
      >
        退出
      </button>
    </div>
  );
}
